import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/shared/context/AuthContext'
import { ProtectedRouteConfig } from '@/shared/types/routes'
import PageLoader from '@/shared/components/PageLoader'

type ProtectedRouteProps = {
    routeConfig: ProtectedRouteConfig
    children: ReactNode
}

export function ProtectedPage({ routeConfig, children }: ProtectedRouteProps) {
    const { isAuthenticated, isLoading, userTypes } = useAuth()
    const { pathname } = useLocation()

    if (isLoading) {
        return <PageLoader />
    }

    if (!isAuthenticated && routeConfig.requireAuth) {
        return <Navigate to={`/?returnUrl=${pathname}`} replace />
    }

    if (routeConfig.allowedTypes?.length) {
        const hasRequiredType =
            userTypes?.some((type) => routeConfig.allowedTypes?.includes(type)) || false

        if (!hasRequiredType) {
            return <Navigate to="/unauthorized" replace />
        }
    }

    return <>{children}</>
}
